var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.879 6H2.116C.941 6.15 0 6.825 0 8.025V9H7.995v-.975C8.074 6.825 7.133 6.15 5.88 6zM4 5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCM2FXUjBhRDBpT0NJZ2FHVnBaMmgwUFNJNUlpQjJhV1YzUW05NFBTSXdJREFnT0NBNUlpQm1hV3hzUFNKdWIyNWxJaUI0Yld4dWN6MGlhSFIwY0RvdkwzZDNkeTUzTXk1dmNtY3ZNakF3TUM5emRtY2lQZ284Y0dGMGFDQmtQU0pOTlM0NE56a2dOa2d5TGpFeE5qUTBRekF1T1RRd05qUWdOaTR4TlNBd0lEWXVPREkwT1RnZ01DQTRMakF5TkRrNFZqbElNaTR4TVRZME5FZzFMamczT1VnM0xqazVOVFEwVmpndU1ESTBPVGhET0M0d056TTRNaUEyTGpneU5EazRJRGN1TVRNek1UZ2dOaTR4TlNBMUxqZzNPU0EyV2lJZ1ptbHNiRDBpZDJocGRHVWlMejRLUEhCaGRHZ2daRDBpVFRRZ05VTTFMak00TURjeElEVWdOaTQxSURNdU9EZ3dOekVnTmk0MUlESXVOVU0yTGpVZ01TNHhNVGt5T1NBMUxqTTRNRGN4SURBZ05DQXdRekl1TmpFNU1qa2dNQ0F4TGpVZ01TNHhNVGt5T1NBeExqVWdNaTQxUXpFdU5TQXpMamc0TURjeElESXVOakU1TWprZ05TQTBJRFZhSWlCbWFXeHNQU0ozYUdsMFpTSXZQZ284TDNOMlp6NEsi";
export { SvgUser as ReactComponent };